<div class="modal">
  <!--########## WIZARD BLOCK [begin] ##########-->
  @if (!editMode && !addMode && !wizardMode && !batchUploadMode) {
    <div class="wizard" [ngClass]="{ eseUnclassifiedCol: imagesDB.unclassified.length > 0 }">
      @for (chapter of chapters; track chapter.tag) {
        @if (chapter.title === 'unclassified') {
          <!--      @if ((images | getImagesByTag: chapter.tag).length > 0) {-->
          <!--        <ng-container></ng-container>-->
          <!--      }-->
          @if (($any(imagesDB)[chapter.tag]?.length ?? 0) > 0) {
            <ng-container
              *ngTemplateOutlet="chapter_display; context: { className: 'exists' }"
            ></ng-container>
          }
        } @else {
          <ng-container
            *ngTemplateOutlet="chapter_display; context: { className: null }"
          ></ng-container>
        }

        <ng-template #chapter_display let-className="className">
          <div class="chapter">
            <div class="title">
              {{ chapter.title | titlecase }} Images
              <nz-space-compact [hidden]="chapter.tag !== 'gallery'" class="add-image-actions">
                <button nz-button nzType="primary" (click)="addImage(chapter.tag, 'gallery-big')">
                  <i nz-icon nzType="file-image" nzTheme="outline"></i>Add Image
                </button>
                <button
                  nz-button
                  nz-dropdown
                  class="add-image-more"
                  [nzDropdownMenu]="menu"
                  nzPlacement="bottomRight"
                >
                  <i nz-icon nzType="ellipsis"></i>
                </button>
              </nz-space-compact>
              <nz-dropdown-menu #menu="nzDropdownMenu">
                <ul nz-menu>
                  <li nz-menu-item (click)="uploadBatchInit()">
                    <nz-upload
                      (nzChange)="uploadBatch($any($event), 'gallery-big')"
                      [nzMultiple]="true"
                      [nzDisabled]="globalUploaded"
                      [nzShowUploadList]="false"
                      nzAccept="image/png image/jpeg"
                    >
                      <a>
                        <span nz-icon nzType="inbox" nzTheme="outline"></span>
                        Add batch Images
                      </a>
                    </nz-upload>
                  </li>
                </ul>
              </nz-dropdown-menu>
            </div>

            @if (className) {
              <b style="color: brown; margin-bottom: 10px; display: block"
                >Unclassified images detected. Please process or delete them.</b
              >
            }

            <cdk-virtual-scroll-viewport
              [itemSize]="7"
              [style.height]="'680px'"
              class="scroll-details"
            >
              <!--IMAGES-->
              <!--          @if ((images | getImagesByTag: chapter.tag).length > 0) {-->
              <!--            <ng-container></ng-container>-->
              <!--          } @else {-->
              <!--            <ng-container *ngTemplateOutlet="noImages"></ng-container>-->
              <!--          }-->
              @if (($any(imagesDB)[chapter.tag]?.length ?? 0) > 0) {
                @if (chapter.tag === 'gallery') {
                  <!--Drop-list for gallery images-->
                  <ng-container
                    *ngTemplateOutlet="dropList; context: { chapter: chapter }"
                  ></ng-container>
                } @else {
                  <!--Simple images list-->
                  <ng-container
                    *ngTemplateOutlet="imgLibrary; context: { chapter: chapter }"
                  ></ng-container>
                }
                @if (chapter.tag === 'cover') {
                  @if ((imagesDB[chapter.tag] | getImagesByTag: 'cover-main').length === 0) {
                    <button nz-button nzType="primary" (click)="addImage('cover', 'cover')">
                      Add Cover Image
                      <!--                      @if ((images | getImagesByTag: 'cover-main').length === 0) { }-->
                    </button>
                  }
                  @if ((imagesDB[chapter.tag] | getImagesByTag: 'cover-ads').length === 0) {
                    <button nz-button nzType="primary" (click)="addImage('cover', 'cover-ads')">
                      Add Image for Ads
                      <!--                      @if ((images | getImagesByTag: 'cover-ads').length === 0) { }-->
                    </button>
                  }
                }
              } @else {
                <button
                  nz-button
                  nzType="primary"
                  [hidden]="chapter.tag === 'unclassified' || chapter.tag === 'gallery'"
                  (click)="addImage(chapter.tag, chapter.tag)"
                >
                  Add {{ chapter.title | titlecase }} Image
                </button>
              }
            </cdk-virtual-scroll-viewport>
          </div>
        </ng-template>
      }
    </div>
  }
  <!--########## WIZARD BLOCK [end] ##########-->

  <ng-template #dropList let-chapter="chapter">
    <ng-container
      *ngTemplateOutlet="imgLibrary; context: { chapter: chapter, dnd: true }"
    ></ng-container>
  </ng-template>

  <!--########## CHAPTER DISPLAY TPL [begin] ##########-->
  <ng-template #imgLibrary let-chapter="chapter" let-dnd="dnd">
    <!--       [cdkDropListData]="images | getImagesByTag: chapter.tag"-->
    <div
      cdkDropList="dnd"
      [cdkDropListData]="$any(imagesDB)[chapter.tag]"
      (cdkDropListDropped)="drop($event, chapter.tag)"
    >
      <!--    <ng-container *ngFor="let item of images | getImagesByTag: chapter.tag">-->
      <nz-spin [nzTip]="spinnerText" [nzSpinning]="spinnerActive && chapter.tag === spinnerChapter">
        @for (item of $any(imagesDB)[chapter.tag]; track item.contentId) {
          <div
            class="gallery-item"
            cdkDrag
            [ngClass]="{ 'gallery-swap': chapter.tag === 'gallery' }"
          >
            @if (chapter.tag === 'gallery') {
              <div class="swap" cdkDragHandle>
                <i nz-icon nzType="holder" class="r90" nzTheme="outline"></i>
              </div>
            }

            @if (item.contentId | getImageDimension | async; as img) {
              <div class="gallery">
                <div
                  class="img"
                  nz-popover
                  nzPopoverPlacement="top"
                  [nzPopoverContent]="
                    calcRecommendation(item, img.x)[1]
                      ? calcRecommendation(item, img.x)[2]
                      : undefined
                  "
                  [ngClass]="{ critical: calcRecommendation(item, img.x)[1] }"
                >
                  <img
                    nz-image
                    [nzSrc]="item.contentId"
                    [src]="item.contentId"
                    [alt]="item.tags[0]"
                  />
                </div>
                <div class="details">
                  @if (chapter.tag === 'unclassified') {
                    <div>Size: {{ img.x }} x {{ img.y }}</div>
                    <button
                      nz-button
                      nz-dropdown
                      class="mr10"
                      [hidden]="img.x < coverMinX"
                      nzSize="small"
                      [nzDropdownMenu]="menu"
                    >
                      <i nz-icon nzType="edit" nzTheme="outline"></i> Process As
                      <i nz-icon nzType="down"></i>
                    </button>
                    <nz-dropdown-menu #menu="nzDropdownMenu">
                      <ul nz-menu>
                        <li
                          nz-menu-item
                          [nzDisabled]="img.x < coverMinX"
                          (click)="manage(item, 'cover')"
                        >
                          Cover
                        </li>
                        <li
                          nz-menu-item
                          [nzDisabled]="img.x < seatMapMinX"
                          (click)="manage(item, 'seat_map')"
                        >
                          Seat Map
                        </li>
                        <li
                          nz-menu-item
                          [nzDisabled]="img.x < galleryMinX"
                          (click)="manage(item, 'gallery-big')"
                        >
                          Gallery
                        </li>
                      </ul>
                    </nz-dropdown-menu>
                  } @else {
                    <div>Size: {{ img.x }} x {{ img.y }}</div>

                    <!--                 [disabled]="img.x <= minSizes[item.tags[0]]"-->
                    <a
                      (click)="manage(item, item.tags[0])"
                      [disabled]="calcRecommendation(item, img.x)[0]"
                      class="mr10"
                      nz-button
                      nzSize="small"
                    >
                      <i nz-icon nzType="edit" nzTheme="outline"></i>
                    </a>
                  }

                  <a
                    nz-popconfirm
                    nzPopconfirmTitle="Are you sure?"
                    (nzOnConfirm)="remove(item, chapter.tag)"
                    nzPopconfirmPlacement="top"
                    nz-button
                    nzDanger
                    nzSize="small"
                  >
                    <i nz-icon nzType="delete" nzTheme="outline"></i>
                  </a>
                </div>
              </div>
            } @else {
              <div class="gallery">
                <div class="img">
                  <!--          <img nz-image [nzSrc]="item.contentId" [src]="item.contentId" [alt]="item.tags[0]">-->
                  <img src="assets/common/noimage.png" alt="Broken image" />
                </div>
                <div class="details">
                  <div>Broken File</div>
                  <a
                    nz-popconfirm
                    nzPopconfirmTitle="Are you sure?"
                    (nzOnConfirm)="remove(item, chapter.tag)"
                    nzPopconfirmPlacement="top"
                    nz-button
                    nzDanger
                    nzSize="small"
                  >
                    <i nz-icon nzType="delete" nzTheme="outline"></i>
                  </a>
                </div>
              </div>
            }
          </div>
        }
      </nz-spin>
    </div>
  </ng-template>
  <!--########## CHAPTER DISPLAY TPL [end] ##########-->

  <!--########## ADD MODE BLOCK [begin] ##########-->
  @if (addMode) {
    <div class="editor">
      <!--CONTROLS TOOL BAR-->
      <ng-container *ngTemplateOutlet="toolbar"></ng-container>

      <!--IF NEED TO ADD SEPARATELY DEFINED TYPE LIKE cover OR cover-ads-->
      <ng-container *ngTemplateOutlet="addNewImageEditor; context: { item: currentHandle }">
      </ng-container>

      <ng-template #addNewImageEditor let-item="item">
        <div class="editors">
          <div class="editor-content">
            <app-image-editor
              #editor
              [initialRatio]="item.ratio"
              [minImageWidth]="item.minWidth"
              [minImageWidthToResize]="item.minUploadWidth"
              [filepath]="editionFile?.contentId"
              (cropChanged)="saveOutput($event, item)"
              [tag]="item.tag"
            ></app-image-editor>
          </div>
        </div>
      </ng-template>
    </div>
  }
  <!--########## ADD MODE BLOCK [end] ##########-->

  <!--########## EDIT MODE BLOCK [begin] ##########-->
  @if (editMode) {
    <div class="editor">
      <ng-container *ngTemplateOutlet="toolbar"></ng-container>

      <!--  @for (item of handleSteps[editionFile.tags[0]]; track $index; let index = $index) {-->
      <!--    <div class="editors"></div>-->
      <!--  }-->
      <div class="editors">
        <!--    @if (index === step) {-->
        <!--      <div class="editor-content"></div>-->
        <!--    }-->
        <!--    @if (editionFile.tags.indexOf(item.baseTag) >= 0) {-->
        <!--      <ng-container></ng-container>-->
        <!--    }-->
        <!--      <div class="editor-content" [hidden]="index != step">-->
        <div class="editor-content">
          <app-image-editor
            [initialRatio]="$any(currentHandle).ratio"
            [minImageWidth]="$any(currentHandle).minWidth"
            [minImageWidthToResize]="$any(currentHandle).minUploadWidth"
            [filepath]="$any(currentHandle).contentId"
            [base64Src]="$any(currentHandle).base64"
            (cropChanged)="saveOutput($event, $any(currentHandle))"
            [tag]="$any(currentHandle).tags[0]"
          ></app-image-editor>
        </div>
        <!--    </ng-container>-->
      </div>
    </div>
  }
  <!--########## EDIT MODE BLOCK [end] ##########-->

  <!--########## WIZARD MODE BLOCK [begin] ##########-->
  @if (wizardMode) {
    <div class="editor">
      <!--STEPS BAR-->
      <!--  @if (definedTypeIndexToAdd === null && handleSteps[currentTag].length > 1) {-->
      <!--    <ng-container></ng-container>-->
      <!--  }-->
      <nz-steps [nzCurrent]="step">
        @for (item of handleSteps; track $index; let index = $index) {
          <nz-step
            [nzTitle]="batchUploadProcess ? '' : item.title"
            [nzStatus]="step === index ? 'process' : index > step ? 'wait' : 'finish'"
            [nzIcon]="
              step === index
                ? batchUploadProcess
                  ? 'gateway'
                  : 'edit'
                : index > step
                  ? 'clock-circle'
                  : item.config.skipped
                    ? 'close'
                    : 'check'
            "
            [nzDescription]="item.details"
          >
          </nz-step>
        }
      </nz-steps>
      <!--  </ng-container>-->

      <!--CONTROLS TOOL BAR-->
      <ng-container *ngTemplateOutlet="wizardToolbar"></ng-container>

      <!--IF NEED TO ADD SEPARATELY DEFINED TYPE LIKE cover OR cover-ads-->
      <ng-container *ngTemplateOutlet="addNewImageEditor; context: { list: handleSteps }">
      </ng-container>

      <!--  <ng-template #noDefinedTypeToAdd>-->
      <!--    not defined-->
      <!--    <ng-container *ngTemplateOutlet="addNewImageEditor; context: {list: handleSteps[currentTag]}"></ng-container>-->
      <!--  </ng-template>-->

      <ng-template #addNewImageEditor let-list="list">
        @for (item of list; track $index; let index = $index) {
          <div class="editors">
            <div class="editor-content" [hidden]="index != step">
              <app-image-editor
                #editor
                [initialRatio]="item.ratio"
                [minImageWidth]="item.minWidth"
                [minImageWidthToResize]="item.minUploadWidth"
                [filepath]="editionFile?.contentId"
                [base64Src]="item.config?.adjustedSrc"
                (cropChanged)="saveOutput($event, item)"
                [tag]="item.tag"
              ></app-image-editor>
            </div>
          </div>
        }
      </ng-template>
    </div>
  }
  <!--########## WIZARD MODE BLOCK [end] ##########-->

  <!--########## BATCH UPLOAD MODE BLOCK [begin] ##########-->
  @if (batchUploadMode) {
    <div class="editor">
      <nz-alert
        nzShowIcon
        nzType="info"
        nzMessage="Your images was checked"
        [nzDescription]="descriptionTemplate2"
        [nzAction]="actionTemplate4"
      ></nz-alert>
      <ng-template #descriptionTemplate2>
        <p>Please review your images. Any incompatible images will be ignored during processing.</p>
      </ng-template>
      <ng-template #actionTemplate4>
        <div class="info-controls">
          <button nz-button nzSize="small" nzType="primary" (click)="gotoWizard()">
            Handle Images
          </button>
          <nz-upload
            (nzChange)="uploadBatch($any($event), 'gallery-big')"
            [nzMultiple]="true"
            [nzDisabled]="globalUploaded"
            [nzShowUploadList]="false"
            nzAccept="image/png image/jpeg"
          >
            <button nz-button nzSize="small" nzType="default">
              <span nz-icon nzType="inbox" nzTheme="outline"></span>
              Add more Images
            </button>
          </nz-upload>
          <button nz-button nzSize="small" nzDanger nzType="default" (click)="uploadBatchCancel()">
            Cancel
          </button>
        </div>
      </ng-template>

      <cdk-virtual-scroll-viewport [itemSize]="7" [style.height]="'680px'" class="scroll-details">
        <div class="batch-gallery mt15">
          @for (img of handleSteps; track $index; let index = $index) {
            <div
              class="img"
              [ngClass]="{ 'not-compatible': img.minUploadWidth > img.config.originSize.x }"
            >
              <img width="200" height="200" [src]="img.config.source" />
              <div class="tag">
                @if (img.config.originSize.x >= img.minUploadWidth) {
                  <span>Ready to handle</span>
                  <a
                    nz-popconfirm
                    nzPopconfirmTitle="Are you sure?"
                    (nzOnConfirm)="removeFromBatch(index)"
                    nzPopconfirmPlacement="top"
                    nz-button
                    nzSize="small"
                  >
                    <i nz-icon nzType="delete" nzTheme="outline"></i>
                  </a>
                } @else {
                  <span>Not Compatible</span>
                  <a (click)="removeFromBatch(index)" nzDanger nz-button nzSize="small">
                    <i nz-icon nzType="delete" nzTheme="outline"></i>
                  </a>
                }
              </div>
            </div>
          }
        </div>
      </cdk-virtual-scroll-viewport>
    </div>
  }
  <!--########## BATCH UPLOAD MODE BLOCK [end] ##########-->

  <!--########## WIZARD-TOOLBAR TPL [begin] ##########-->
  <ng-template #wizardToolbar>
    <div class="toolbar">
      <div class="description">
        @if (batchUploadProcess) {
          <ng-container>Please adjust the Image manually.</ng-container>
        } @else {
          <ng-container>{{ handleSteps[step].description }}</ng-container>
        }
      </div>
      <div class="controls">
        <button
          nz-button
          nzType="primary"
          [disabled]="!batchUploadMode"
          nzDanger
          (click)="cancel()"
        >
          Cancel
        </button>

        <!--***** GLOBAL UPLOAD Button *****-->
        <nz-upload
          (nzChange)="upload($any($event), handleSteps[step].baseTag)"
          [nzDisabled]="globalUploaded || batchUploadProcess"
          [nzShowUploadList]="false"
          nzAccept="image/png image/jpeg"
        >
          <button nz-button nzType="primary" [disabled]="globalUploaded || batchUploadProcess">
            <i nz-icon nzType="upload"></i>
            {{ editionFile?.contentId ? 'Change Image' : 'Upload Image' }}
          </button>
        </nz-upload>

        <div class="vd"></div>

        <!--***** PREV Button *****-->
        <button nz-button nzType="default" [disabled]="step === 0" (click)="prev()">
          <i nz-icon nzType="left" nzTheme="outline"></i> Prev
        </button>
        <!--***** SKIP Button *****-->
        <button
          nz-button
          nzType="default"
          nzDanger
          [disabled]="!handleSteps[step].canSkip || batchUploadProcess"
          (click)="next(true)"
        >
          Skip <i nz-icon nzType="double-right" nzTheme="outline"></i>
        </button>

        <!--***** NEXT / FINISH BUTTONS *****-->
        @if (step === handleSteps.length - 1) {
          <button
            nz-button
            nzType="primary"
            [disabled]="handleSteps[step].imageExists != true"
            (click)="finish()"
          >
            <i nz-icon nzType="save" nzTheme="outline"></i> Finish
          </button>
        } @else {
          <button
            nz-button
            nzType="primary"
            [disabled]="handleSteps[step].imageExists != true"
            (click)="next()"
          >
            Next <i nz-icon nzType="right" nzTheme="outline"></i>
          </button>
        }
        <!--***** NEXT / FINISH BUTTONS [end] *****-->
      </div>
    </div>
  </ng-template>
  <!--########## WIZARD TOOLBAR TPL [end] ##########-->

  <!--########## TOOLBAR (add/edit modes) TPL [begin] ##########-->
  <ng-template #toolbar>
    <div class="toolbar">
      <div class="description">
        {{ $any(currentHandle)?.description ?? '' }}
      </div>
      <div class="controls">
        <button nz-button nzType="primary" nzDanger (click)="cancel()">Cancel</button>

        <!--***** GLOBAL UPLOAD Button *****-->
        <nz-upload
          (nzChange)="upload($any($event), null)"
          [nzShowUploadList]="false"
          nzAccept="image/*"
        >
          <button nz-button nzType="primary">
            <i nz-icon nzType="upload"></i>
            {{ editionFile?.contentId ? 'Change Image' : 'Upload Image' }}
          </button>
        </nz-upload>

        <div class="vd"></div>

        <!--***** PREV Button *****-->
        <button nz-button nzType="default" [disabled]="step === 0" (click)="prev()">
          <i nz-icon nzType="left" nzTheme="outline"></i> Prev
        </button>
        <!--***** SKIP Button *****-->
        <button
          nz-button
          nzType="default"
          nzDanger
          [disabled]="editMode || addMode"
          (click)="next(true)"
        >
          Skip <i nz-icon nzType="double-right" nzTheme="outline"></i>
        </button>

        <!--***** NEXT / FINISH BUTTONS *****-->
        <button
          nz-button
          nzType="primary"
          [disabled]="$any(currentHandle)?.imageExists != true"
          (click)="finish()"
        >
          <i nz-icon nzType="save" nzTheme="outline"></i> Finish
        </button>
        <!--***** NEXT / FINISH BUTTONS [end] *****-->
      </div>
    </div>
  </ng-template>
  <!--########## TOOLBAR (add/edit modes) TPL [end] ##########-->
</div>

<ng-container *nzModalFooter>
  <button nz-button nzType="primary" (click)="closeModal()">Close</button>
</ng-container>
